import type { Particle } from "./types";

export class Particles {
  list: Particle[] = [];

  snow(viewW: number, viewH: number, n: number, cameraX: number): void {
    for (let i = 0; i < n; i++) {
      this.list.push({
        x: cameraX + Math.random() * (viewW + 200) - 40,
        y: Math.random() * viewH,
        vx: -18 - Math.random() * 22,
        vy: 28 + Math.random() * 50,
        life: 8 + Math.random() * 8,
        max: 12,
        size: 1 + Math.random() * 2.2,
        kind: "snow",
        color: "rgba(255,255,255,0.85)",
      });
    }
  }

  burst(x: number, y: number, color: string, n = 16): void {
    for (let i = 0; i < n; i++) {
      const a = Math.random() * Math.PI * 2;
      const s = 40 + Math.random() * 160;
      this.list.push({
        x,
        y,
        vx: Math.cos(a) * s,
        vy: Math.sin(a) * s - 40,
        life: 0.35 + Math.random() * 0.4,
        max: 0.7,
        size: 2 + Math.random() * 3,
        kind: "spark",
        color,
      });
    }
  }

  dust(x: number, y: number): void {
    for (let i = 0; i < 7; i++) {
      this.list.push({
        x: x + (Math.random() - 0.5) * 20,
        y,
        vx: (Math.random() - 0.5) * 60,
        vy: -20 - Math.random() * 40,
        life: 0.3 + Math.random() * 0.25,
        max: 0.5,
        size: 2 + Math.random() * 2,
        kind: "dust",
        color: "rgba(210,190,160,0.5)",
      });
    }
  }

  update(dt: number, cameraX: number, viewW: number, viewH: number, wind: number): void {
    const next: Particle[] = [];
    for (const p of this.list) {
      p.life -= dt;
      if (p.life <= 0) continue;
      p.x += (p.vx + (p.kind === "snow" ? wind : 0)) * dt;
      p.y += p.vy * dt;
      if (p.kind === "snow") {
        p.x += Math.sin(p.y * 0.04 + p.size) * 18 * dt;
        if (p.y > viewH + 8) {
          p.y = -8;
          p.x = cameraX + Math.random() * (viewW + 160);
        }
        if (p.x < cameraX - 80) p.x = cameraX + viewW + 40;
      } else {
        p.vy += 420 * dt;
      }
      next.push(p);
    }
    this.list = next;
    const snowCount = this.list.filter((p) => p.kind === "snow").length;
    if (snowCount < 90) this.snow(viewW, viewH, 90 - snowCount, cameraX);
  }

  draw(ctx: CanvasRenderingContext2D, alpha = 1): void {
    for (const p of this.list) {
      const a = (p.life / p.max) * alpha;
      ctx.globalAlpha = p.kind === "snow" ? 0.55 + p.size * 0.12 : a;
      ctx.fillStyle = p.color;
      ctx.beginPath();
      ctx.arc(p.x, p.y, p.size, 0, Math.PI * 2);
      ctx.fill();
    }
    ctx.globalAlpha = 1;
  }
}
